import './mission.scss';

const Mission = () => (
  <div className="mission-page">
    <section className="mission-hero">
      <div className="mission-hero__overlay" />
      <div className="mission-hero__content">
        <h1>Mission Statement</h1>
      </div>
    </section>

    <section className="mission-details">
      <div className="mission-details__inner">
        <article className="mission-details__card">
          <p className="mission-details__intro">
            We provide the following member services:
          </p>
          <ol className="mission-details__list">
            <li className="mission-details__item">Promotes and protects the interests of self insurers.</li>
            <li className="mission-details__item">Assists, advises, and uses its resources in developing and implementing common objectives among members.</li>
            <li className="mission-details__item">Advances legislation of common interest and opposes undesirable legislation or regulations.</li>
            <li className="mission-details__item">Processes and distributes relevant information to its members.</li>
            <li className="mission-details__item">Coordinates common interest appearances before the General Assembly and governmental committees.</li>
            <li className="mission-details__item">In specific situations involving rights of Missouri self-insurers, aids individual members.</li>
            <li className="mission-details__item">Provides a forum for discussion of members' common problems.</li>
            <li className="mission-details__item">Works in cooperation with, and provides specialized information to, other State and/or national organizations with common goals and interests.</li>
            <li className="mission-details__item">Sponsors educational, informational and networking events, seminars and conferences to further the knowledge and awareness of its members and offer opportunities to broaden their understanding of issues and services through interaction with other members and those services that support the employers and trusts in their self-insured programs.</li>
          </ol>
        </article>
      </div>
    </section>
  </div>
);

export default Mission;
